import styles from './Primitives.module.scss';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Content } from '@wienenergiegithub/ui-next';

export const StartDot = ({ pulse }) => (
  <div
    className={classNames(styles.startDot, {
      [styles.pulse]: pulse,
      'pulse-animation': pulse,
    })}
    role="presentation"
  />
);

StartDot.propTypes = {
  pulse: PropTypes.bool,
};

StartDot.defaultProps = {
  pulse: false,
};

export const Spacer = ({ id, spacer }) => (
  <>
    {spacer.map(element => (
      <div
        className={styles.spacerDot}
        key={`${id}-${element}`}
        role="presentation"
      />
    ))}
  </>
);

Spacer.propTypes = {
  id: PropTypes.string.isRequired,
  spacer: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export const DateLabel = ({ date, id, className }) => (
  <Content
    as="p"
    className={classNames(styles.dateLabel, className)}
    id={id}
    noSpacing
  >
    {date}
  </Content>
);

DateLabel.defaultProps = {
  className: PropTypes.string,
  date: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

DateLabel.defaultProps = {
  className: null,
};
